import axios from './axios';

export const getFAQ = () =>
  axios
    .get('https://atlasvpn.zendesk.com/api/v2/help_center/articles')
    .then((response) => response.data.articles);
